import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getBasketsKey } from '../../utils/keys';
export const useBaskets = (options) => {
    const { useQueryOptions, variables } = options || {};
    const { client } = useTribeClient();
    const basketsKey = getBasketsKey(variables);
    return useQuery(basketsKey, () => client.billing.baskets(variables), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useBaskets.js.map